<section id="section-core-team" class="row" #meetTheTeam>
  <div class="col-xs-12">
    <div class="row">
      <h2 class="col-xs-12 heading">The Core Team</h2>
    </div>

    <div class="row">
      <p class="subheading-black col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">The founding team of Finzy
        are professionals who have excelled in their fields ranging across finance, technology, product,
        sales, marketing and leadership.</p>
    </div>

    <div class="row">
      <div class="col-xs-10 col-xs-offset-1">
        <div class="row col-container">
          <div class="col-xs-12 col-sm-6 col-lg-4 card-team-member">
            <img src="https://res.cloudinary.com/finzy/image/upload/v1538986872/amit_ihskhe.jpg"
                 alt="Amit More, Founder & CEO"
                 class="img-responsive">
            <div class="row">
              <div class="card-team-member-description col-xs-12">
                <p class="name">Amit More</p>
                <p class="designation">Founder & CEO</p>
                <p class="introduction">Amit brings vision, business strategy and core financial
                  sector domain
                  knowledge to Finzy. Amit is an expert in the Indian Banking & Financial
                  Services industry with
                  over 19 years of experience across ICICI Bank, Credit Suisse AG and
                  Edelweiss.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-lg-4 card-team-member">
            <img src="https://res.cloudinary.com/finzy/image/upload/v1538986872/abhinandan_aukpdl.jpg"
                 alt="Abhinandan Sangam, Co-founder & CTO">
            <div class="row">
              <div class="card-team-member-description col-xs-12">
                <p class="name">Abhinandan Sangam</p>
                <p class="designation">Co-founder & CTO</p>
                <p class="introduction">Abhinandan is an expert in building capabilities across
                  geographies. He
                  oversees Tech and Product at finzy and has over 22 years of
                  experience with organizations like ThoughtWorks, Sabre, MindTree, Siemens,
                  Amadeus.
                </p>
              </div>
            </div>
          </div>
          <div class="clearfix visible-sm visible-md"></div>
          <div class="col-xs-12 col-sm-6 col-lg-4 card-team-member">
            <img src="https://res.cloudinary.com/finzy/image/upload/v1538986872/vishwas_ztkchg.jpg"
                 alt="Vishwas Dixit, Co-founder & CMO">
            <div class="row">
              <div class="card-team-member-description col-xs-12">
                <p class="name">Vishwas Dixit</p>
                <p class="designation">Co-founder & CMO</p>
                <p class="introduction">Vishwas is the face of Finzy. With 25 years of Sales,
                  Marketing &
                  Distribution experience in organizations like Toyota, TVS and Dunlop,he
                  brings in expertise in
                  market expansion projects and creating distribution networks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
